// extracted by mini-css-extract-plugin
export default {"container":"KakaoChannelBanner_container__Z6ssz","textWrap":"KakaoChannelBanner_textWrap__uUlBQ","addButton":"KakaoChannelBanner_addButton__ZFHu7"};